/* eslint-disable new-cap, no-unused-vars */
import Component from '@bythepixel/component-loader';
import simpleParallax from 'simple-parallax-js';

const DEFAULTS = {
  parallaxTargetSelector: '[data-comp-parallax-target]',
  parallaxContainerSelector: '[data-comp-parallax-container]',
};

export default class AnimationController extends Component {
  static selector = '[data-comp-parallax-controller]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);
    this.containers = containerEl.querySelectorAll(options.parallaxContainerSelector);
    this.mount();
  }

  mount() {
    [...this.containers].forEach((container) => {
      let target;
      const isResponsiveImage = container.dataset.compParallaxIsResponsiveImage === 'true' || false;

      if (isResponsiveImage) {
        target = container.querySelector('img');
      } else {
        target = container;
      }

      const parallax = new simpleParallax(target, {
        scale: 1.1,
      });
    });
  }
}
